import logger from "@airhelp/node-logger";
import type { LanguageCode } from "config/languages";
import getRegularPageUrl from "./getRegularPageUrl";
import getStoryblokPageUrl from "./getStoryblokPageUrl";
import type { PageName, RegularPageName, StoryblokPageName } from "./types";
import { REGULAR_PAGES, STORYBLOK_PAGES } from "./types";

export const getPageUrl = (language: LanguageCode, pageName: PageName) => {
  if (([...REGULAR_PAGES] as PageName[]).includes(pageName))
    return getRegularPageUrl(language, pageName as RegularPageName);

  if (([...STORYBLOK_PAGES] as PageName[]).includes(pageName))
    return getStoryblokPageUrl(language, pageName as StoryblokPageName);

  logger.error(`Unknown pageName used in getPageUrl(${language}, ${pageName}).`);

  return "/";
};
